export async function contactInfo(url: RequestInfo, token: string) {

    return await fetch(url + '/api/contact-info', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                'token': token,
            }
        )
    })
        .then(response => response.json())
        .catch(err => {
            console.log(err);
        });
}